module.exports = __webpack_public_path__ + "img/banner.59121db3.png";